import React from "react";
import "../css/Navigation.css";

const Navigation = () => {
  return (
    <nav className="navigation">
        <ul className="navigation-list" >
            <li><a href="#header">Bio</a></li>
            <li><a href="#research">Research</a> </li>
            <li><a href="#teaching">Teaching</a></li>
            <li><a href="/CV-new.pdf" target="_blank" rel="noopener noreferrer">CV</a></li>
        </ul>
    </nav>
  );
};

export default Navigation;